export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Clientes',
      url: '/clientes',
      icon:'fa fa-user'
    
      
    },
    {
      name: 'Abonos',
      url: '/abonos',
      icon:'fa fa-usd'
    
      
    },
    
    {
      name: 'Inventario',
      icon:'fa fa-archive',
      url: '/inventario'
   
    },
    {
      name: 'Ventas',
      
      icon: 'fa fa-money',
      
      children: [
        {
          name:'Punto de venta',
          url:'/ventas',
          icon:'fa fa-money'


        },
        {
          name:'Gestión de ventas',
          url:'/venta',
          icon:'fa fa-address-book'


        }
      ]
     
    },
    {

      name: 'Reportes',
      url:'/reportes',
      icon: 'fa fa-file'
     
    },
    {
      name:'Mensajes',
      url:'/mensajes',
      icon: 'fa fa-comment'
    },
   /* {
      name:'Configuraciones',
      url:'/configuracion',
      icon:'fa fa-cogs'

    },*/
    {
      name: 'Cerrar Sesión',
      url: '/cerrarSesion',
      icon: 'fa fa-sign-out'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js